<script>
    import { Carousel, Slide } from 'vue-carousel';
    import VTooltip from 'v-tooltip'
    export default {
        components: {
            Carousel,
            Slide,
            VTooltip,
        },
        props: {
            load_user: {
                type: Object,
                default: null,
            },
            load_organization: {
                type: Object,
                default: null,
            },
            load_user_email: {
                type: String,
                default: null,
            },
            load_purchased: {
                type: Boolean,
                default: false,
            }
        },
        data: function () {
            return {
                monthly: true,
                showPurchaseModal: false,
                showUpgradeModal: false,
                showHomeVideoModal: false,
                chosenPlan: null,
                user: null,
                organization: null,
                accountEmail: null,
                purchased: false,
                loaded: false,
                soloplancost: 19,
                plans: {
                    planb10: {
                        yearly: 199,
                        monthly: 19,
                        templates: 5,
                        employees: 40,
                    },
                    planb20: {
                        yearly: 399,
                        monthly: 39,
                        templates: 10,
                        employees: 100,
                    },
                    planb30: {
                        yearly: 599,
                        monthly: 59,
                        templates: 15,
                        employees: 250,
                    },
                },
                sale: {
                    active: false,
                    solo: 0,
                    plan1monthly: 0,
                    plan1yearly: 0,
                    plan2monthly: 0,
                    plan2yearly: 0,
                }
            }
        },
        mounted() {
            //console.log('Component mounted.')
            if (this.load_user) {
                this.user = this.load_user;
            }
            if (this.load_organization) {
                this.organization = this.load_organization;
            }
            if (this.load_user_email) {
                this.accountEmail = this.load_user_email;
            }
            if (this.load_purchased) {
                this.purchased = this.load_purchased;
            }
            this.loaded = true;
        },
        computed: {
            pricingPlanSolo: function() {
                if (this.sale.active) {
                    var price = this.soloplancost + this.sale.solo;
                    return "$" + price;
                } else {
                    return "$" + this.soloplancost;
                }
                
            },
            chosenPlanPrice: function() {
                //if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    if (this.monthly) {
                        return "$" + this.plans[this.pricingIndex].monthly;
                    } else {
                        return "$" + this.plans[this.pricingIndex].yearly;
                    }
                // } else {
                //     return '';
                // }
            },
            chosenPlanBaseSigs: function() {
                //if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    return this.plans[this.pricingIndex].templates;
                //} else {
                //    return '';
                //}
            },
            chosenPlanEmployees: function() {
                //if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    return this.plans[this.pricingIndex].employees;
                //} else {
                //    return '';
                //}
            },
        },
        methods: {
            chosenPlanSavings: function(planname) {
                //console.log(planname);
                //if (this.chosenPlan && this.plans.hasOwnProperty(this.chosenPlan)) {
                    if (this.sale.active) {
                        return "Save $" + ((this.plans[planname].monthly * 12) - (this.plans[planname].yearly + this.sale.plan1yearly)) + ' paid yearly!';
                    } else {
                        return "Save $" + ((this.plans[planname].monthly * 12) - this.plans[planname].yearly) + ' paid yearly';
                    }
                // } else {
                //     return '';
                // }
            },
            startThePurchase(plan) {
                if (this.purchased) {
                    if (plan == "solo" && this.organization.plan_name == "solo") {
                        window.location.href = "/signatures";
                    } else {
                        this.chosenPlan = plan;
                        this.showUpgradeModal = true;
                    }
                } else {
                    this.chosenPlan = plan;
                    this.showPurchaseModal = true;
                }
            }
        }
    }
</script>
